// extracted by mini-css-extract-plugin
module.exports = {"container":"vertical-label-text_container__7wvHC","label":"vertical-label-text_label__1HYWV","text":"vertical-label-text_text__2i25V"};